import { module } from "angular";

import type { IConfigurationGroup } from "App/Modules/Models";
import { ConfigurationGroupType } from "App/Modules/Models";
import type { IDefaultNamingService } from "./IDefaultNamingService";

export class DefaultNamingService implements IDefaultNamingService {
    public static $inject = ["$translate"];

    private pendingRequests = 0;

    constructor(private readonly $translate: angular.translate.ITranslateService) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.nameConfigurationGroup = this.nameConfigurationGroup.bind(this);
    }

    public nameConfigurationGroup(configurationGroup: IConfigurationGroup): IConfigurationGroup {
        if (configurationGroup.name != null) {
            return configurationGroup;
        }

        let key;

        switch (configurationGroup.type) {
            case ConfigurationGroupType.Care:
                key = "Entities.Default.CareConfiguration";
                break;
            case ConfigurationGroupType.Detection:
                key = "Entities.Default.DetectionConfiguration";
                break;
            case ConfigurationGroupType.Recording:
                key = "Entities.Default.RecordingConfiguration";
                break;
            case ConfigurationGroupType.Monitoring:
                key = "Entities.Default.MonitoringConfiguration";
                break;
            case ConfigurationGroupType.Reporting:
                key = "Entities.Default.ReportingConfiguration";
                break;
            default:
                throw Error("Unknown configuration group type");
        }

        configurationGroup.name = this.$translate.instant(key, configurationGroup, "messageformat");

        return configurationGroup;
    }
}

module("mmServices").service("irDefaultNamingService", DefaultNamingService);
